module.exports = __webpack_public_path__ + "media/images/fallback/figures/search_thumbnail/default_article_image_0-44cb0e7883a81013c27f85ec47de6060.png";